import { MutationTree } from "vuex/types";
import State from "./state";
import { SET_MEMBER_INTERIOR_SETTINGS_DATA } from "./mutation-types";
import { IMemberInteriorSettings } from "../../../models/interfaces/memberInteriorSettings/iMemberInteriorSettings";
import { MemberInteriorSettings } from "../../../models/classes/memberInteriorSettings/memberInteriorSettings";

const mutations: MutationTree<State> = {
  [SET_MEMBER_INTERIOR_SETTINGS_DATA](state: State, data: IMemberInteriorSettings) {
    const settingsData: any = Object.keys(data).reduce((acc, key) => {
      const _acc = acc;
      if (data[key] !== undefined)
        _acc[key] = data[key];

      return _acc;
    }, {});

    state.settings = new MemberInteriorSettings(settingsData);
  },

};

export default mutations;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/memberInteriorSettings/mutations.ts